/* eslint-disable @typescript-eslint/no-use-before-define */
import React from 'react'
import ReactDOM from 'react-dom'

import template from './template.html'
import SettingsSiteSelector from '~/reactapp/Settings/SettingsSiteSelector'

export default [directive]

function directive() {
  return {
    replace: true,
    restrict: 'E',
    controllerAs: 'vm',
    bindToController: true,
    template,
    scope: {
      companySettings: '<',
      sites: '<',
      applyChanges: '&',
    },
    controller: [Controller],
    link: Link,
  }
}

function Controller() {
  // Angular 1 note: Althrough apply changes updates companySettings
  // siteServiceBasePathsV2 configuration, $onChanges will not trigger updates
  // as it only does shallow check
  const applyChanges = (websitesConfiguration) => {
    this.applyChanges({ websitesConfiguration })
  }

  this.$onChanges = () => {
    const loadError = this.sites && this.sites.error
    this.render &&
      this.render({
        companySettings: this.companySettings,
        sites: this.sites,
        loadError,
        applyChanges,
      })
  }
}

function reactRenderFactory(
  angularScope,
  rootElement,
  SettingsSiteSelectorReact
) {
  angularScope.$on('$destroy', () =>
    ReactDOM.unmountComponentAtNode(rootElement)
  )
  return (props) => {
    ReactDOM.render(<SettingsSiteSelectorReact {...props} />, rootElement)
  }
}

function Link(scope, el) {
  const rootElement = el.find('#settingsSiteSelectorReact')[0]
  scope.vm.render = reactRenderFactory(scope, rootElement, SettingsSiteSelector)
}
